import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import HorizontalDividerElement from '../../../components/form-elements/extras/horizontal-divider';
import TextBoxElement from '../../../components/form-elements/extras/text';

const ExtraElements = {
	HORIZONTAL_DIVIDER: {
		type: ElementConstants.EXTRAS.HORIZONTAL_DIVIDER,
		component: <HorizontalDividerElement />
	},
	TEXT_BOX: {
		type: ElementConstants.EXTRAS.TEXT_BOX,
		component: <TextBoxElement />
	}
}

export default ExtraElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/elements/editor/extras.js